import { useMutation, useQueryClient } from "react-query";
import { mutatePostFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";
import { Auth } from "../../interface";

export const useAddKey = () => {
  const queryClient = useQueryClient();
  return useMutation<Auth, never, any>(
    (data) => mutatePostFn(ENDPOINTS.ADD_PROJECT_KEYS, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([]);
      },
    }
  );
};
